import React from 'react';
import PropTypes from 'prop-types';
import i18next from 'i18next';
import IconButton from '../IconButton/IconButton';
/**
 * Component holding the reply button and associated components
 */
const ReplyButtonWrapper = ({ handleReplyButtonClick }) => (
  <IconButton
    label={i18next.t('reply')}
    baseIcon={['fal', 'comment']} // outline icon
    activatedIcon={['fal', 'comment']}
    onClick={handleReplyButtonClick}
  />
);

ReplyButtonWrapper.propTypes = {
  handleReplyButtonClick: PropTypes.func.isRequired
};

export default ReplyButtonWrapper;
